(function($){
    'use strict';
    /**
     * 简单分页类
     */
    class BlogAllPagination {
        constructor (totalPageCount) {
            if (!totalPageCount) return
            this.state = {
                pageNumber: 1,
                totalPageCount
            }
        }

        init (paramsObj) {
            let state = this.state
            // 页面元素的外部容器
            state.container = paramsObj.container || 'body'
            // 不包括开头和结尾的两个固定按钮外，中间最多展示几个数字页码按钮
            state.maxShowBtnCount = paramsObj.maxShowBtnCount || 5
            // 所有的页码元素，包括上一页、下一页
            state.pCName = paramsObj.pCName || 'page-li',
                // 当选中页码时添加的类名class
                state.activeCName = paramsObj.activeCName || 'page-active',
                // 代表页码数字的属性
                state.dataNumberAttr = paramsObj.dataNumberAttr || 'data-number',
                // 上一页 按钮的类名class
                state.prevCName = paramsObj.prevCName || 'page-prev',
                // 下一页 按钮的类名class
                state.nextCName = paramsObj.nextCName || 'page-next',
                // 禁用 上一页 按钮时给此按钮添加的类名class
                state.disbalePrevCName = paramsObj.disbalePrevCName || 'no-prev',
                // 禁用 下一页 按钮时给此按钮添加的类名class
                state.disbaleNextCName = paramsObj.disbaleNextCName || 'no-next',
                // 不包括 上一页 下一页 省略号 按钮的页码元素类名
                state.pageNumberCName = paramsObj.pageNumberCName || 'page-number'
            // 触发切换页面的事件
            state.swEvent = paramsObj.swEvent || 'click'
            // 切换页面时调用的函数
            state.onPageChange = paramsObj.onPageChange
            // 当需要省略符号占位时，确定 active的位置
            state.totalPageCount > state.maxShowBtnCount + 2 && (state.activePosition = Math.ceil(state.maxShowBtnCount / 2))
            this.renderPageDOM()
        }

        switchPage () {
            let state = this.state
            let pCNameList = this.selectorEle('.' + state.pCName, true)
            let pageNumber
            pCNameList.forEach(item => {
                item.addEventListener(state.swEvent, e => {
                    const currentPageEle = e.target
                    if (this.hasClass(currentPageEle, state.activeCName)) return
                    let dataNumberAttr = currentPageEle.getAttribute(state.dataNumberAttr)
                    if (dataNumberAttr) {
                        // 点击 数字 按钮
                        pageNumber = +dataNumberAttr
                    } else if (this.hasClass(currentPageEle, state.prevCName)) {
                        // 点击 上一页 按钮
                        state.pageNumber > 1 && (pageNumber = state.pageNumber - 1)
                    } else if (this.hasClass(currentPageEle, state.nextCName)) {
                        // 点击 下一页 按钮
                        state.pageNumber < state.totalPageCount && (pageNumber = state.pageNumber + 1)
                    }
                    pageNumber && this.gotoPage(pageNumber)
                })
            })
        }
        gotoPage (pageNumber) {
            let state = this.state
            let evaNumberLi = this.selectorEle('.' + state.pageNumberCName, true)
            let len = evaNumberLi.length
            if (!len || this.isIllegal(pageNumber)) return
            // 清除 active 样式
            this.removeClass(this.selectorEle(`.${state.pCName}.${state.activeCName}`), state.activeCName)
            if (state.activePosition) {
                let rEllipseSign = state.totalPageCount - (state.maxShowBtnCount - state.activePosition) - 1
                // 左边不需要出现省略符号占位
                if (pageNumber <= state.maxShowBtnCount && (pageNumber < rEllipseSign)) {
                    if (+evaNumberLi[1].getAttribute(state.dataNumberAttr) > 2) {
                        for (let i = 1; i < state.maxShowBtnCount + 1; i++) {
                            evaNumberLi[i].innerText = i + 1
                            evaNumberLi[i].setAttribute(state.dataNumberAttr, i + 1)
                        }
                    }
                    this.hiddenEllipse('.ellipsis-head')
                    this.hiddenEllipse('.ellipsis-tail', false)
                    this.addClass(evaNumberLi[pageNumber - 1], state.activeCName)
                }
                // 两边都需要出现省略符号占位
                if (pageNumber > state.maxShowBtnCount && pageNumber < rEllipseSign) {
                    // 针对 maxShowBtnCount===1 的特殊处理
                    this.hiddenEllipse('.ellipsis-head', pageNumber === 2 && state.maxShowBtnCount === 1)
                    this.hiddenEllipse('.ellipsis-tail', false)
                    for (let i = 1; i < state.maxShowBtnCount + 1; i++) {
                        evaNumberLi[i].innerText = pageNumber + (i - state.activePosition)
                        evaNumberLi[i].setAttribute(state.dataNumberAttr, pageNumber + (i - state.activePosition))
                    }
                    this.addClass(evaNumberLi[state.activePosition], state.activeCName)
                }
                // 右边不需要出现省略符号占位
                if (pageNumber >= rEllipseSign) {
                    this.hiddenEllipse('.ellipsis-tail')
                    this.hiddenEllipse('.ellipsis-head', false)
                    if (+evaNumberLi[len - 2].getAttribute(state.dataNumberAttr) < state.totalPageCount - 1) {
                        for (let i = 1; i < state.maxShowBtnCount + 1; i++) {
                            evaNumberLi[i].innerText = state.totalPageCount - (state.maxShowBtnCount - i) - 1
                            evaNumberLi[i].setAttribute(state.dataNumberAttr, state.totalPageCount - (state.maxShowBtnCount - i) - 1)
                        }
                    }
                    this.addClass(evaNumberLi[(state.maxShowBtnCount + 1) - (state.totalPageCount - pageNumber)], state.activeCName)
                }
            } else {
                // 不需要省略符号占位
                this.addClass(evaNumberLi[pageNumber - 1], state.activeCName)
            }
            state.pageNumber = pageNumber
            state.onPageChange && state.onPageChange(state)
            // 判断 上一页 下一页 是否可使用
            this.switchPrevNextAble()
        }

        switchPrevNextAble () {
            let state = this.state
            let prevBtn = this.selectorEle('.' + state.prevCName)
            let nextBtn = this.selectorEle('.' + state.nextCName)
            // 当前页已经是第一页，则禁止 上一页 按钮的可用性
            state.pageNumber > 1
                ? (this.hasClass(prevBtn, state.disbalePrevCName) && this.removeClass(prevBtn, state.disbalePrevCName))
                : (!this.hasClass(prevBtn, state.disbalePrevCName) && this.addClass(prevBtn, state.disbalePrevCName))
            // 当前页已经是最后一页，则禁止 下一页 按钮的可用性
            state.pageNumber >= state.totalPageCount
                ? (!this.hasClass(nextBtn, state.disbaleNextCName) && this.addClass(nextBtn, state.disbaleNextCName))
                : (this.hasClass(nextBtn, state.disbaleNextCName) && this.removeClass(nextBtn, state.disbaleNextCName))
        }

        renderPageDOM () {
            // 渲染页码DOM
            let state = this.state
            let pageContainer = this.selectorEle(state.container)
            if (!pageContainer) return
            let { totalPageCount, pCName, prevCName, disbalePrevCName, pageNumberCName,
                activeCName, dataNumberAttr, maxShowBtnCount,nextCName, disbaleNextCName } = state
            let paginationStr = `
      <ul class="pagination">
      <li class="${pCName} ${prevCName} ${disbalePrevCName} icon-g-08">
        <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-006" viewBox="0 0 24 24">
            <g>
            \t<path d="M16.736,3.417c0,0.169-0.059,0.319-0.176,0.449l-8.32,8.301l8.32,8.301c0.117,0.13,0.176,0.28,0.176,0.449
            \t\ts-0.059,0.319-0.176,0.449c-0.065,0.052-0.137,0.094-0.215,0.127c-0.078,0.032-0.156,0.049-0.234,0.049s-0.156-0.017-0.234-0.049
            \t\tc-0.078-0.033-0.149-0.075-0.215-0.127l-8.75-8.75c-0.117-0.13-0.176-0.28-0.176-0.449c0-0.169,0.059-0.319,0.176-0.449l8.75-8.75
            \t\tc0.13-0.117,0.28-0.176,0.449-0.176c0.169,0,0.319,0.059,0.449,0.176C16.677,3.098,16.736,3.248,16.736,3.417z"/>
            </g>
        </svg>
      </li>  
      <li class="${pCName} ${pageNumberCName} ${activeCName}" ${dataNumberAttr}='1'>1</li>
      `
            if (totalPageCount - 2 > maxShowBtnCount) {
                paginationStr += `
        <li class="${pCName} number-ellipsis ellipsis-head" style="display: none;">...</li>`
                for (let i = 2; i < maxShowBtnCount + 2; i++) {
                    paginationStr += `<li class="${pCName} ${pageNumberCName} ${i === 1 ? activeCName : ''}" ${dataNumberAttr}='${i}'>${i}</li>`
                }
                paginationStr += `
        <li class="${pCName} number-ellipsis ellipsis-tail">...</li>
        <li class="${pCName} ${pageNumberCName}" ${dataNumberAttr}='${totalPageCount}'>${totalPageCount}</li>
        `
            } else {
                for (let i = 2; i <= totalPageCount; i++) {
                    paginationStr += `<li class="${pCName} ${pageNumberCName}" ${dataNumberAttr}='${i}'>${i}</li>`
                }
            }
            paginationStr += `<li class="icon-g-09 ${pCName} ${nextCName}${totalPageCount === 1 ? ' ' + disbaleNextCName : ''}">
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-theme-007" viewBox="0 0 24 24">
                    <g>
                    \t<path d="M6.708,20.917c0-0.169,0.059-0.319,0.176-0.449l8.32-8.301l-8.32-8.301c-0.117-0.13-0.176-0.28-0.176-0.449
                    \t\tc0-0.169,0.059-0.319,0.176-0.449c0.13-0.117,0.279-0.176,0.449-0.176c0.169,0,0.318,0.059,0.449,0.176l8.75,8.75
                    \t\tc0.117,0.13,0.176,0.28,0.176,0.449c0,0.169-0.059,0.319-0.176,0.449l-8.75,8.75c-0.065,0.052-0.137,0.094-0.215,0.127
                    \t\tc-0.078,0.032-0.156,0.049-0.234,0.049s-0.156-0.017-0.234-0.049c-0.078-0.033-0.15-0.075-0.215-0.127
                    \t\tC6.767,21.236,6.708,21.086,6.708,20.917z"/>
                    </g>
                </svg>
            </li></ul>`
            pageContainer.innerHTML = paginationStr
            // 切换页码
            this.switchPage()
        }

        isIllegal (pageNumber) {
            let state = this.state
            return (
                state.pageNumber === pageNumber || Math.ceil(pageNumber) !== pageNumber ||
                pageNumber > state.totalPageCount || pageNumber < 1 ||
                typeof pageNumber !== 'number' || pageNumber !== pageNumber
            )
        }

        hiddenEllipse (selector, shouldHidden = true) {
            this.selectorEle(selector).style.display = shouldHidden ? 'none' : ''
        }

        selectorEle (selector, all = false) {
            return all ? document.querySelectorAll(selector) : document.querySelector(selector)
        }

        hasClass (eleObj, className) {
            return eleObj.classList.contains(className);
        }

        addClass (eleObj, className) {
            eleObj.classList.add(className);
        }

        removeClass (eleObj, className) {
            if (this.hasClass(eleObj, className)) {
                eleObj.classList.remove(className);
            }
        }
    }

    $(document).ready(function(){

        /**
         * 博客菜单相关js逻辑
         */

        var listbtn = document.getElementById('categoriess');
        var listShow = document.getElementById('list-show-mb');
        var flag = 0;
        listbtn.onclick = function() {
            if (flag === 0) {
                listShow.style.display = 'block';
                flag = 1;
            } else {
                listShow.style.display = 'none';
                flag = 0;
            }
        }

        /**
         * 博客列表页相关js逻辑
         * 1.文章模板渲染；
         * 2.分页器初始化；
         * 3.分页点击跳转逻辑；
         */

        let blogArticlesAll = sortListByCreatedTime(window._blog_articles_string || []); // 某些集合下的所有文章
        let articleTotal = blogArticlesAll.length; // 文章总数
        const pageSize = 10; // 每一页条数
        const articlesContainer = $('.articles-list'); // 文章列表容器
        let blogAllPagination = null; // 分页器对象

        initPagination();
        scrollToArticle();

        function scrollToArticle() {
            if(window.location.pathname == '/blogs/all') return;
            let height = $('.blogs-info').offset().top || $('.nav-mb').offset().top;
            document.documentElement.scrollTop = height;
        }

        /**
         * 初始化分页器
         */
        function initPagination() {
            const pages = Math.ceil(articleTotal / pageSize);
            // 初始化渲染第一页
            handleRederArticle(1);
            $('.pagintion-template').hide();
            if(!(pages > 1)) return;

            $('.pagintion-template').show();
            $('.page-skip-container').show();
            blogAllPagination = new BlogAllPagination(pages);
            blogAllPagination.init({
                container: '.blog-all-pagintion',
                maxShowBtnCount: 5,
                onPageChange: function(state) {
                    handleRederArticle(state.pageNumber);
                }
            })

            // 初始化页码placeholder
            $(".skip-page-input" ).val('').attr( "placeholder" , pages);
            // 监听pageInput输入，限制输入范围
            $(".skip-page-input" ).off('input').on('input', function() {
                const val = $(this).val() > pages ? pages : $(this).val();
                $(this).val(`${val}`.replace(/\D|^0/g,''));
            })
            // 监听 pageInput focus active 状态
            $('.skip-page-input').off('focus').on('focus', function() {
                $('#skipToPage').addClass('skip-page-active');
            })
            // 监听 pageInput blur，按钮移除 active 状态
            $('.skip-page-input').off('blur').on('blur', function() {
                $('#skipToPage').removeClass('skip-page-active');
            })
            // 跳转指定页数
            $('#skipToPage').off('click').on('click',function() {
                blogAllPagination.gotoPage(Number($('.skip-page-input').val()))
            })

        }

        function getTimeStamp (timeFormatStr) { return new Date(timeFormatStr).getTime(); };
        function sortListByCreatedTime(articles) {
            if(!articles || !articles.length) return [];
            return articles.sort(function(a, b){
                return getTimeStamp(b.created_at) - getTimeStamp(a.created_at);
            })
        }

        function findBlogHandle(blog_id) {
            let result = '';
            $('.blogs-ul-container').find('li').each(function() {
                if($(this).attr('data-id') == blog_id) {
                    result = $(this).attr('data-handle');
                }
            })
            return result;
        }

        /**
         * 根据当前页码，渲染文章列表
         */
        function handleRederArticle(page) {
            const articles = blogArticlesAll.slice((page - 1) * pageSize, page * pageSize);

            const templates = articles.map(function(article) {
                const blogHandle = findBlogHandle(article.blog_id);

                const articleUrl = `/blogs/${blogHandle}/${article.handle}`;
                const d = new Date(article.created_at);
                const created_at = `${d.toDateString().split(" ")[1]} ${d.getDate()}, ${d.getFullYear()}`;
                const bodyHtml = (article.body_html || '').replace(/<[^<>]+>/g, "");

                // 生成响应式图片标签
                let imageHtml = '';
                if (article.image && article.image.src) {
                    const imageSrc = article.image.src;
                    const imageAlt = article.image.alt || article.title;
                    
                    // 使用 Shopify 图片转换参数生成响应式图片
                    const baseUrl = imageSrc.split('?')[0]; // 移除现有参数
                    const srcMobile = baseUrl + '?width=400';
                    const srcDesktop = baseUrl + '?width=800';
                    
                    imageHtml = `<picture>
                        <source media="(max-width: 768px)" srcset="${srcMobile}">
                        <img 
                            src="${srcDesktop}" 
                            alt="${imageAlt}"
                            loading="lazy"
                        />
                    </picture>`;
                } else {
                    // 占位图片
                    imageHtml = `<div style="width: 100%; height: 100%; background: #f5f5f5; display: flex; align-items: center; justify-content: center; color: #999;">
                        <svg width="48" height="48" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
                        </svg>
                    </div>`;
                }

                return `<div class="article-card">
          <div class="article-card__image">
            <a href="${articleUrl}">${imageHtml}</a>
          </div>
          <div class="article-card__content">
            <div class="article-card__content--title">
              <a href="${articleUrl}">${article.title}</a>
            </div>
            <div class="article-card__content--preview">
              <a href="${articleUrl}">${article.summary_html || bodyHtml || '-'}</a>
            </div>
            <div class="article-card__content--author">
              <a href="${articleUrl}">
                by <span>${article.author}</span>&nbsp;&nbsp;|&nbsp;
                <span>${ created_at}</span>
              </a>
            </div>
          </div>
        </div>
      `
            })
            articlesContainer.html(templates);
        }
    })


})(window.jQuery);
